import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import './LandingRecurso.css';

const API_LEADS    = 'https://centrocomunicar.com/api-comunicar/endpoints/leads.php';
const API_RECURSOS = 'https://centrocomunicar.com/api-comunicar/endpoints/leads.php?action=recurso&slug=';

/* ── Icons ── */
const IconCheck     = () => (<svg viewBox="0 0 20 20" fill="none" width="18" height="18"><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.25)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCheckBig  = () => (<svg viewBox="0 0 24 24" fill="none" width="48" height="48"><circle cx="12" cy="12" r="11" fill="#d4f4e8"/><path d="M7 12l4 4 6-7" stroke="#4db88a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconDownload  = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/><polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconStar      = () => (<svg viewBox="0 0 24 24" fill="#f59e0b" width="16" height="16"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const IconShield    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconWhatsapp  = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconArrow     = () => (<svg viewBox="0 0 20 20" fill="none" width="18" height="18"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconPdf       = () => (<svg viewBox="0 0 24 24" fill="none" width="28" height="28"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPlay2     = () => (<svg viewBox="0 0 24 24" fill="none" width="28" height="28"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M10 8l6 4-6 4V8z" fill="currentColor"/></svg>);
const IconKit       = () => (<svg viewBox="0 0 24 24" fill="none" width="28" height="28"><rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconTemplate  = () => (<svg viewBox="0 0 24 24" fill="none" width="28" height="28"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6M9 13h6M9 17h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClose     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconUser      = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/></svg>);
const IconMail      = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/><polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPhone     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.41a16 16 0 006.29 6.29l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

/* ── Tipo icons map ── */
const TIPO_ICON = { pdf: <IconPdf/>, clase: <IconPlay2/>, muestra: <IconKit/>, plantilla: <IconTemplate/> };
const TIPO_LABEL = { pdf:'PDF Descargable', clase:'Clase Gratuita', muestra:'Recurso Didáctico', plantilla:'Plantilla Editable' };

/* ── Testimonios estáticos ── */
const testimonios = [
  { nombre:'Ana G.', perfil:'Terapeuta de lenguaje', texto:'Increíble recurso, lo apliqué en mis sesiones la misma semana que lo descargué.', estrellas:5 },
  { nombre:'María T.', perfil:'Madre de familia', texto:'Por fin encuentro materiales pensados para familias. ¡Gracias Comunicar!', estrellas:5 },
  { nombre:'Carla R.', perfil:'Docente de inicial', texto:'El protocolo me ahorró horas de trabajo. Lo recomiendo a todas mis colegas.', estrellas:5 },
];

/* ══════════════════════════════════════
   COMPONENTE PRINCIPAL
══════════════════════════════════════ */
export default function LandingRecurso() {
  const { slug }            = useParams();
  const [searchParams]      = useSearchParams();

  const [recurso,  setRecurso]  = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  // Form
  const [form,     setForm]     = useState({ nombre:'', email:'', telefono:'', perfil:'profesional' });
  const [formErr,  setFormErr]  = useState({});
  const [enviando, setEnviando] = useState(false);
  const [exito,    setExito]    = useState(null); // { titulo, archivo_url, puntos }

  // UTM params
  const utm = {
    source:   searchParams.get('utm_source')   || searchParams.get('source') || 'directo',
    medium:   searchParams.get('utm_medium')   || '',
    campaign: searchParams.get('utm_campaign') || '',
  };
  // Detectar fuente por utm_source
  const fuente = utm.source.includes('instagram') ? 'instagram'
    : utm.source.includes('facebook') ? 'facebook'
    : utm.source.includes('whatsapp') ? 'whatsapp'
    : utm.source.includes('tiktok')   ? 'tiktok'
    : utm.source;

  /* ── Fetch recurso ── */
  useEffect(() => {
    if (!slug) { setError('Recurso no especificado'); setLoading(false); return; }
    fetch(API_RECURSOS + slug)
      .then(r => r.json())
      .then(json => {
        if (!json.success) throw new Error(json.message);
        setRecurso(json.data);
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [slug]);

  /* ── Scroll to form ── */
  const scrollToForm = () => {
    document.getElementById('ld-form')?.scrollIntoView({ behavior:'smooth', block:'center' });
  };

  /* ── Validar ── */
  const validar = () => {
    const errs = {};
    if (!form.nombre.trim())                         errs.nombre   = 'Ingresa tu nombre';
    if (!form.email || !/\S+@\S+\.\S+/.test(form.email)) errs.email = 'Email no válido';
    if (form.telefono && !/^\+?[\d\s\-]{7,}$/.test(form.telefono)) errs.telefono = 'Teléfono no válido';
    setFormErr(errs);
    return Object.keys(errs).length === 0;
  };

  /* ── Enviar ── */
  const handleSubmit = async e => {
    e.preventDefault();
    if (!validar()) return;
    setEnviando(true);
    try {
      const res  = await fetch(`${API_LEADS}?action=lead`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          recurso_slug: slug,
          fuente,
          utm_source:   utm.source,
          utm_medium:   utm.medium,
          utm_campaign: utm.campaign,
        }),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.message);
      setExito({
        titulo:      json.data?.recurso?.titulo || recurso?.titulo,
        archivo_url: json.data?.recurso?.archivo_url,
        puntos:      json.data?.puntos || 50,
      });
      window.scrollTo({ top:0, behavior:'smooth' });
    } catch(err) {
      setFormErr({ general: err.message || 'Error al procesar. Intenta nuevamente.' });
    } finally {
      setEnviando(false);
    }
  };

  const setF = (k, v) => { setForm(f=>({...f,[k]:v})); if(formErr[k]) setFormErr(f=>({...f,[k]:''})); };

  /* ── Loading ── */
  if (loading) return (
    <div className="ld-loading">
      <div className="ld-loading__spinner"/>
      <p>Cargando recurso…</p>
    </div>
  );

  /* ── Error ── */
  if (error || !recurso) return (
    <div className="ld-error">
      <h2>Recurso no disponible</h2>
      <p>{error || 'Este recurso no existe o no está disponible.'}</p>
      <Link to="/recursos" className="ld-btn-primary">Ver todos los recursos</Link>
    </div>
  );

  const tipoLabel = TIPO_LABEL[recurso.tipo] || 'Recurso gratuito';
  const tipoIcon  = TIPO_ICON[recurso.tipo]  || <IconPdf/>;

  /* ── ÉXITO ── */
  if (exito) return (
    <div className="ld-page">
      <nav className="ld-nav">
        <Link to="/" className="ld-nav__logo"><span className="ld-nav__dot"/>Comunicar</Link>
      </nav>
      <div className="ld-exito">
        <div className="ld-exito__card">
          <IconCheckBig/>
          <span className="ld-exito__badge">¡Registro exitoso!</span>
          <h1>Tu recurso está listo</h1>
          <p>Podrás descargarlo en el siguiente enlace</p>

          {exito.archivo_url && (
            <a href={exito.archivo_url} target="_blank" rel="noopener noreferrer" className="ld-btn-primary ld-btn-lg">
              <IconDownload/> Descargar ahora
            </a>
          )}

      

          <div className="ld-exito__next">
            <p>Mientras esperas tu recurso, explora:</p>
            <div className="ld-exito__links">
              <Link to="/formaciones" className="ld-exito__link">Ver formaciones →</Link>
              <Link to="/recursos"    className="ld-exito__link">Más recursos →</Link>
              <Link to="/comunidad"   className="ld-exito__link">Únete a la comunidad →</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  /* ══════════════════════════════════════
     LANDING PRINCIPAL
  ══════════════════════════════════════ */
  return (
    <div className="ld-page">

      {/* NAV mínimo */}
      <nav className="ld-nav">
        <Link to="/" className="ld-nav__logo"><span className="ld-nav__dot"/>Comunicar</Link>
        <button className="ld-nav__cta" onClick={scrollToForm}>
          Descargar gratis <IconArrow/>
        </button>
      </nav>

      {/* ── HERO ── */}
      <section className="ld-hero">
        <div className="ld-hero__bg">
          <div className="ld-hero__blob ld-hero__blob--a"/>
          <div className="ld-hero__blob ld-hero__blob--b"/>
          <div className="ld-hero__grid" aria-hidden="true"/>
        </div>

        <div className="ld-hero__inner">

          {/* Columna izquierda — copy */}
          <div className="ld-hero__left">
            <div className="ld-hero__badges">
              <span className="ld-badge ld-badge--tipo">
                {tipoIcon} {tipoLabel}
              </span>
              <span className="ld-badge ld-badge--gratis">GRATIS</span>
            </div>

            <h1 className="ld-hero__h1">{recurso.titulo}</h1>

            {recurso.descripcion && (
              <p className="ld-hero__desc">{recurso.descripcion}</p>
            )}

            <ul className="ld-hero__checks">
              <li><IconCheck/> Descarga inmediata tras registrarte</li>
              <li><IconCheck/> Sin pagos ni tarjeta requerida</li>
              <li><IconCheck/> Ganas 50 puntos de beneficios</li>
              <li><IconCheck/> Recibes novedades y recursos exclusivos</li>
            </ul>

            {/* Social proof */}
            <div className="ld-social-proof">
              <div className="ld-social-proof__avatares">
                {['A','M','C','L','P'].map((l,i) => (
                  <div key={i} className="ld-avatar" style={{'--i':i}}>{l}</div>
                ))}
              </div>
              <div>
                <div className="ld-stars">{[1,2,3,4,5].map(i=><IconStar key={i}/>)}</div>
                <p><strong>{recurso.total_descargas + 240}+ profesionales</strong> ya lo descargaron</p>
              </div>
            </div>

            <button className="ld-btn-primary ld-btn-hero" onClick={scrollToForm}>
              <IconDownload/> Quiero mi recurso gratis
            </button>
          </div>

          {/* Columna derecha — preview del recurso */}
          <div className="ld-hero__right">
            <div className={`ld-preview ld-preview--${recurso.categoria?.toLowerCase().replace(/\s/g,'') || 'lenguaje'}`}>
              <div className="ld-preview__badge">{tipoLabel}</div>
              <div className="ld-preview__icon">{tipoIcon}</div>
              <h3 className="ld-preview__titulo">{recurso.titulo}</h3>
              <div className="ld-preview__meta">
                <span>● {recurso.categoria || 'Terapia del lenguaje'}</span>
                <span>● Comunicar 2025</span>
              </div>
              <div className="ld-preview__lock">
                <div className="ld-lock">
                  <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
                    <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/>
                    <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  <span>Regístrate para desbloquear</span>
                </div>
              </div>
              {/* Decoración */}
              <div className="ld-preview__deco"/>
            </div>

            {/* Urgencia sutil */}
            <div className="ld-urgencia">
              <span className="ld-urgencia__dot"/>
              <span><strong>{12 + (recurso.total_descargas % 8)} personas</strong> lo descargaron hoy</span>
            </div>
          </div>

        </div>
      </section>

      {/* ── FORMULARIO ── */}
      <section className="ld-form-section" id="ld-form">
        <div className="ld-form-wrap">
          <div className="ld-form-head">
            <h2>Descarga tu recurso <em>gratuito</em></h2>
            <p>Completa tus datos y recibe el recurso al instante en tu correo.</p>
          </div>

          <form className="ld-form" onSubmit={handleSubmit} noValidate>

            {formErr.general && (
              <div className="ld-form__error-general">
                <IconClose/> {formErr.general}
              </div>
            )}

            {/* Nombre */}
            <div className={`ld-field ${formErr.nombre?'ld-field--error':''}`}>
              <label>Tu nombre <span className="ld-req">*</span></label>
              <div className="ld-field__wrap">
                <span className="ld-field__icon"><IconUser/></span>
                <input
                  type="text"
                  placeholder="Ej: Ana Rodríguez"
                  value={form.nombre}
                  onChange={e=>setF('nombre',e.target.value)}
                  className="ld-input"
                  autoComplete="name"
                />
              </div>
              {formErr.nombre && <span className="ld-field__msg">{formErr.nombre}</span>}
            </div>

            {/* Email */}
            <div className={`ld-field ${formErr.email?'ld-field--error':''}`}>
              <label>Tu correo electrónico <span className="ld-req">*</span></label>
              <div className="ld-field__wrap">
                <span className="ld-field__icon"><IconMail/></span>
                <input
                  type="email"
                  placeholder="tu@correo.com"
                  value={form.email}
                  onChange={e=>setF('email',e.target.value)}
                  className="ld-input"
                  autoComplete="email"
                />
              </div>
              {formErr.email && <span className="ld-field__msg">{formErr.email}</span>}
            </div>

            {/* Teléfono */}
            <div className={`ld-field ${formErr.telefono?'ld-field--error':''}`}>
              <label>WhatsApp / Teléfono <span className="ld-opt">(opcional)</span></label>
              <div className="ld-field__wrap">
                <span className="ld-field__icon"><IconPhone/></span>
                <input
                  type="tel"
                  placeholder="+51 999 000 111"
                  value={form.telefono}
                  onChange={e=>setF('telefono',e.target.value)}
                  className="ld-input"
                  autoComplete="tel"
                />
              </div>
              {formErr.telefono && <span className="ld-field__msg">{formErr.telefono}</span>}
            </div>

            {/* Perfil */}
            <div className="ld-field">
              <label>Soy…</label>
              <div className="ld-perfil-tabs">
                {[
                  { val:'profesional', label:'Profesional de salud' },
                  { val:'familia',     label:'Familia / Cuidador' },
                  { val:'estudiante',  label:'Estudiante' },
                  { val:'otro',        label:'Otro' },
                ].map(({val,label}) => (
                  <button
                    key={val}
                    type="button"
                    className={`ld-perfil-tab ${form.perfil===val?'ld-perfil-tab--active':''}`}
                    onClick={()=>setF('perfil',val)}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              className={`ld-btn-primary ld-btn-submit ${enviando?'ld-btn-submit--loading':''}`}
              disabled={enviando}
            >
              {enviando
                ? <><span className="ld-spinner"/> Procesando…</>
                : <><IconDownload/> Descargar gratis ahora</>
              }
            </button>

            {/* Garantías */}
            <div className="ld-garantias">
              <span><IconShield/> Sin spam, te lo prometemos</span>
              <span>·</span>
              <span>Puedes darte de baja cuando quieras</span>
            </div>

          </form>
        </div>
      </section>

      {/* ── TESTIMONIOS ── */}
      <section className="ld-testimonios">
        <div className="ld-testimonios__inner">
          <p className="ld-section-label">Lo que dicen quienes ya lo tienen</p>
          <div className="ld-testimonios__grid">
            {testimonios.map((t,i) => (
              <div className="ld-tesimonio" key={i}>
                <div className="ld-stars ld-stars--small">
                  {[...Array(t.estrellas)].map((_,j)=><IconStar key={j}/>)}
                </div>
                <p>"{t.texto}"</p>
                <div className="ld-tesimonio__autor">
                  <div className="ld-avatar ld-avatar--sm">{t.nombre[0]}</div>
                  <div>
                    <strong>{t.nombre}</strong>
                    <span>{t.perfil}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA FINAL ── */}
      <section className="ld-cta-final">
        <div className="ld-cta-final__inner">
          <div className="ld-cta-final__bg"/>
          <h2>¿Listo para mejorar tu práctica?</h2>
          <p>Únete a más de {recurso.total_descargas + 240} profesionales y familias que ya usan nuestros recursos.</p>
          <button className="ld-btn-white" onClick={scrollToForm}>
            <IconDownload/> Descargar {tipoLabel} gratis
          </button>
        </div>
      </section>

      {/* ── FOOTER MÍNIMO ── */}
      <footer className="ld-footer">
        <div className="ld-footer__inner">
          <Link to="/" className="ld-nav__logo"><span className="ld-nav__dot"/>Comunicar</Link>
          <div className="ld-footer__links">
            <Link to="/formaciones">Formaciones</Link>
            <Link to="/recursos">Recursos</Link>
            <Link to="/comunidad">Comunidad</Link>
            <Link to="/articulos">Blog</Link>


            <a href="https://centrocomunicar.com/virtual/login/index.php"
            target="_blank" rel="noopener noreferrer"
            className="nav__aula-btn">
            <span className="aula-icon">📖</span>
            Aula Virtual
          </a>

          </div>
          <p>© 2025 Comunicar – Desarrollo y Lenguaje</p>
        </div>
      </footer>

    </div>
  );
}